import React from "react";
import { Form } from "react-bootstrap";
import TextInput from "../TextInput";

function TextInputWithLabel({
  label,
  name,
  value,
  type,
  onChange,
  placeholder,
  defaultValue,
  autoComplete
}) {
  return (
    <Form.Group className="mb-3">
      <Form.Label>{label}</Form.Label>
      <TextInput
        type={type}
        name={name}
        value={value}
        placeholder={placeholder}
        onChange={onChange}
        defaultValue={defaultValue}
        autoComplete={autoComplete}
      />
    </Form.Group>
  );
}

export default TextInputWithLabel;
